import { checkCookie, removeCookieByVersion, getPreferences, setCheckboxesFromPreferences } from './core/cookie-manager';
import gdprModal from './elements/el-modal';
import gdprDrawer from './elements/el-sidebar';
import cookieActions from './cookies/cookie-actions';
import managerServices from './manager/manager-services';
import type { GdprAction } from './types';

const modModal = new gdprModal();
const modDrawer = new gdprDrawer();
const modActions = new cookieActions();
const modManagerServices = new managerServices();

export default class cookieSolution {

    init(): void {
        removeCookieByVersion();

        const hasCookie = checkCookie();

        // Initialize sidebar (always needed for "Cookie preference" button)
        modDrawer.init((action: GdprAction, parentId: string) => {
            modActions.handleAction(action, parentId);
        });

        if (!hasCookie) {
            // Show modal for first-time visitors
            modModal.show(
                // onCustomize: close modal, open sidebar
                () => {
                    modDrawer.show();
                },
                // onAction: handle accept/decline from modal
                (action: GdprAction) => {
                    modActions.handleAction(action, 'gdprModal');
                }
            );
        } else {
            // Cookie exists: apply stored preferences to services
            modManagerServices.checkPreferences();

            // Restore checkbox states in sidebar
            const preferences = getPreferences();
            setCheckboxesFromPreferences(preferences);
        }

        // Bind "Cookie preference" button (footer/page button)
        this.bindOpenCustomizer();
    }

    private bindOpenCustomizer(): void {
        const btn = document.getElementById('btn-gdpr-open-customizer');
        if (!btn) return;

        btn.addEventListener('click', (e) => {
            e.preventDefault();

            // Restore checkbox states before showing sidebar
            const preferences = getPreferences();
            setCheckboxesFromPreferences(preferences);

            modDrawer.show();
        });
    }
}
